import script from "./SubmissionComposer.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionComposer.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionComposer.vue?vue&type=style&index=0&id=0aa10473&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa10473"]])

export default __exports__